import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

/** Seller reviews buyer GRNs via the existing approval list. */
export default function SellerCmProductionReviewGrnPage() {
  const { rfqId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/approve-goods-receipt-list", {
      replace: true,
      state: { cmRfqId: rfqId ? Number(rfqId) : null },
    });
  }, [rfqId, navigate]);

  return (
    <div className="container py-5">
      <p className="text-muted mb-0">Opening GRN review…</p>
    </div>
  );
}
